import React from 'react';

export function Wrapper(props: React.HTMLProps<HTMLDivElement>) {
    return <div className="CustomScrollbar-wrapper"  {...props} />
}

export function Content(props: React.HTMLProps<HTMLDivElement>) {
    return <div className="CustomScrollbar-content"  {...props} />
}

export function TrackVertical(props: React.HTMLProps<HTMLDivElement>) {
    return <div className="CustomScrollbar-track CustomScrollbar-trackVertical"  {...props} />
}

export function TrackHorizontal(props: React.HTMLProps<HTMLDivElement>) {
    return <div className="CustomScrollbar-track CustomScrollbar-trackHorizontal"  {...props} />
}

export function ThumbVertical(props: React.HTMLProps<HTMLDivElement>) {
    return <div className="CustomScrollbar-thumb CustomScrollbar-thumbVertical"  {...props} />
}

export function ThumbHorizontal(props: React.HTMLProps<HTMLDivElement>) {
    return <div className="CustomScrollbar-thumb CustomScrollbar-thumbHorizontal"  {...props} />
}
